import { defineComponent, nextTick } from "vue";
import axios from 'axios'

import { store } from '#stores/ectropion.js'
import { VForm } from "vuetify/components";

import Form from '../form.js'

export default defineComponent({
    mixins: [ Form ],
    components: {
    },
    data() {
        return {
            store,
            form: store.ectropionForm
        }
    },
    methods: {

    }
})
